import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, CheckCircle, ChevronDown, X } from 'lucide-react';
export function TestimonialsSection() {
  const [showAll, setShowAll] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const allTestimonials = [{
    id: 1,
    name: 'Enzo M.',
    verified: true,
    rating: 5,
    text: 'No le tenía fe, pero me motivó. Lo compré por impulso viéndolo en tiktok y lo usé de verdad. Ver los cuadritos llenos motiva muchísimo.',
    image: 'https://cdn.magicpatterns.com/uploads/31h79zXVvyn5fU6mMdSQnP/1.jpg'
  }, {
    id: 2,
    name: 'María Luz S.',
    verified: true,
    rating: 5,
    text: 'Aprobadísimooo!! Tengo TDAH. Esta plantilla me da estructura visual. Y ahora estoy más enfocada y sin tanta culpa.',
    image: 'https://cdn.magicpatterns.com/uploads/jtYzFzMojySsK2VitJqcJR/2.jpg'
  }, {
    id: 3,
    name: 'Franco R.',
    verified: true,
    rating: 5,
    text: 'Es bien completo. Que tenga mensual, semanal y diaria hace diferencia.',
    image: 'https://cdn.magicpatterns.com/uploads/xwhVQpdv99NW9PgoSkiqyu/3.jpg'
  }, {
    id: 4,
    name: 'Florencia C.',
    verified: true,
    rating: 5,
    text: 'Lo usé para educar a mis hijos. Imprimimos varias copias. Mis hijos marcan sus hábitos y yo volví al gym.',
    image: 'https://cdn.magicpatterns.com/uploads/kb28cCWGPe8sqSBUno2M89/4.jpg'
  }, {
    id: 5,
    name: 'Matías B.',
    verified: true,
    rating: 5,
    text: 'La parte semanal es clave. Un hábito por vez y siento que avanzo de verdad.',
    image: 'https://cdn.magicpatterns.com/uploads/q9f2ggJKYXJPHaVe6rQMDr/5.jpg'
  }, {
    id: 6,
    name: 'Agustín C.',
    verified: true,
    rating: 5,
    text: 'Las imprimí y las pegué en el escritorio. Verlas me recuerda hacerlo y poner menos excusas.',
    image: 'https://cdn.magicpatterns.com/uploads/31h79zXVvyn5fU6mMdSQnP/1.jpg'
  },
  // Additional testimonials that show when "Ver más" is clicked
  {
    id: 7,
    name: 'Carolina P.',
    verified: true,
    rating: 5,
    text: 'Estas plantillas son una gran guía. Si me desvío, al día siguiente retomo. No me castiga, me guía, y eso me sirvió un montón.',
    image: 'https://cdn.magicpatterns.com/uploads/jtYzFzMojySsK2VitJqcJR/2.jpg'
  }, {
    id: 8,
    name: 'Sebastián L.',
    verified: true,
    rating: 5,
    text: 'Me sirvió para dormir mejor. Anoté una rutina nocturna y dejé el celu lejos. Parece una tontería, pero funcionó.',
    image: 'https://cdn.magicpatterns.com/uploads/xwhVQpdv99NW9PgoSkiqyu/3.jpg'
  }, {
    id: 9,
    name: 'Lucía R.',
    verified: true,
    rating: 5,
    text: 'Lo compré escéptica. Ahora llevo 3 semanas seguidas. El sistema visual realmente funciona.',
    image: 'https://cdn.magicpatterns.com/uploads/kb28cCWGPe8sqSBUno2M89/4.jpg'
  }, {
    id: 10,
    name: 'Diego M.',
    verified: true,
    rating: 5,
    text: 'Simple pero efectivo. No necesito apps complicadas, solo imprimir y marcar. Eso es lo que necesitaba.',
    image: 'https://cdn.magicpatterns.com/uploads/q9f2ggJKYXJPHaVe6rQMDr/5.jpg'
  }];
  const visibleTestimonials = showAll ? allTestimonials : allTestimonials.slice(0, 6);
  return <>
      <section className="py-24 bg-[#050505] relative overflow-hidden" data-id="element-207">
        {/* Background Effects */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-208">
          <motion.div animate={{
          scale: [1, 1.2, 1],
          opacity: [0.03, 0.06, 0.03]
        }} transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-[#FF6B35]" style={{
          filter: 'blur(100px)'
        }} data-id="element-209" />
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-210">
          {/* Header */}
          <div className="text-center mb-16" data-id="element-211">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} data-id="element-212">
              <h2 className="text-3xl md:text-4xl font-black text-white uppercase tracking-tight mb-4" data-id="element-213">
                Lo que dicen{' '}
                <span className="text-[#FF6B35]" style={{
                textShadow: '0 0 20px rgba(255, 107, 53, 0.4)'
              }} data-id="element-214">
                  quienes ya lo usan
                </span>
              </h2>
              <div className="w-24 h-1 bg-[#FF6B35] mx-auto rounded-full" style={{
              boxShadow: '0 0 10px #FF6B35'
            }} data-id="element-215"></div>
            </motion.div>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-gray-400 mt-6 max-w-2xl mx-auto" data-id="element-216">
              Más de 127 personas ya recuperaron su enfoque y constancia
            </motion.p>
          </div>

          {/* Grid - 2 columns on mobile, 2 columns on desktop */}
          <div className="grid grid-cols-2 gap-3 md:gap-6" data-id="element-217">
            <AnimatePresence mode="popLayout" data-id="element-218">
              {visibleTestimonials.map((testimonial, index) => <TestimonialCard key={testimonial.id} testimonial={testimonial} index={index} onImageClick={() => setSelectedImage(testimonial.image)} data-id="element-219" />)}
            </AnimatePresence>
          </div>

          {/* Ver Más / Ver Menos Button */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="text-center mt-12" data-id="element-220">
            <button onClick={() => setShowAll(!showAll)} className="group inline-flex items-center gap-2 px-8 py-4 bg-[#121212] border-2 border-[#FF6B35]/30 rounded-xl text-white font-bold uppercase tracking-wide hover:bg-[#FF6B35]/10 hover:border-[#FF6B35] transition-all duration-300" style={{
            boxShadow: '0 0 20px rgba(255, 107, 53, 0.1)'
          }} data-id="element-221">
              {showAll ? 'Ver menos' : 'Ver más testimonios'}
              <motion.div animate={{
              y: [0, 3, 0],
              rotate: showAll ? 180 : 0
            }} transition={{
              duration: 1.5,
              repeat: Infinity,
              rotate: {
                duration: 0.3,
                repeat: 0
              }
            }} data-id="element-222">
                <ChevronDown className="w-5 h-5 text-[#FF6B35]" data-id="element-223" />
              </motion.div>
            </button>
          </motion.div>
        </div>
      </section>

      {/* Image Modal */}
      <AnimatePresence data-id="element-224">
        {selectedImage && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setSelectedImage(null)} className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 cursor-pointer" data-id="element-225">
            <motion.button initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.8
        }} onClick={() => setSelectedImage(null)} className="absolute top-4 right-4 p-2 bg-white/10 hover:bg-white/20 rounded-full transition-colors z-10" data-id="element-226">
              <X className="w-6 h-6 text-white" data-id="element-227" />
            </motion.button>

            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} onClick={e => e.stopPropagation()} className="relative max-w-5xl max-h-[90vh] w-full" data-id="element-228">
              <img src={selectedImage} alt="Vista ampliada" className="w-full h-full object-contain rounded-lg" data-id="element-229" />
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function TestimonialCard({
  testimonial,
  index,
  onImageClick
}: {
  testimonial: {
    id: number;
    name: string;
    verified: boolean;
    rating: number;
    text: string;
    image: string;
  };
  index: number;
  onImageClick: () => void;
}) {
  return <motion.div layout initial={{
    opacity: 0,
    y: 30
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    scale: 0.95
  }} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} className="bg-[#121212] rounded-xl md:rounded-2xl overflow-hidden border border-white/5 hover:border-[#FF6B35]/30 transition-all duration-300 group" data-id="element-230">
      {/* Image */}
      <div onClick={onImageClick} className="relative aspect-[4/3] overflow-hidden bg-gradient-to-br from-gray-800 to-black cursor-pointer" data-id="element-231">
        <img src={testimonial.image} alt={`Testimonio de ${testimonial.name}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-232" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#121212] via-transparent to-transparent opacity-60" data-id="element-233" />

        {/* Hover overlay */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center" data-id="element-234">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileHover={{
          opacity: 1,
          scale: 1
        }} className="opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-235">
            <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center" data-id="element-236">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-237">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" data-id="element-238" />
              </svg>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Content */}
      <div className="p-3 md:p-6" data-id="element-239">
        {/* Name and Verification */}
        <div className="flex items-center justify-between mb-2" data-id="element-240">
          <div className="flex items-center gap-1" data-id="element-241">
            <h3 className="text-sm md:text-lg font-bold text-white" data-id="element-242">
              {testimonial.name}
            </h3>
            {testimonial.verified && <div className="flex items-center gap-1 text-[#22C55E]" data-id="element-243">
                <CheckCircle className="w-3 h-3 md:w-4 md:h-4" data-id="element-244" />
                <span className="text-xs font-medium hidden md:inline" data-id="element-245">
                  Verificada
                </span>
              </div>}
          </div>
        </div>

        {/* Stars */}
        <div className="flex gap-0.5 md:gap-1 mb-2" data-id="element-246">
          {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-3 h-3 md:w-4 md:h-4 fill-[#FFB800] text-[#FFB800]" data-id="element-247" />)}
        </div>

        {/* Review Text */}
        <p className="text-gray-300 text-xs md:text-sm leading-relaxed" data-id="element-248">
          {testimonial.text}
        </p>
      </div>
    </motion.div>;
}